import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { AppState } from '../../core';
import { Task, Building, TaskStatus } from '../../core/models';
import { TabDirective } from 'ngx-bootstrap/tabs/public_api';
import { BuildingService, PathTestService, ScoutTaskService, UserService } from '../../core/services';
import { TaskScheduleCommentsComponent } from './task-schedule-comments/task-schedule-comments.component';
import { UserDoc } from '../../core/schema/user-schema';
import { NgForm } from '@angular/forms';
import { AppTab } from '../../core/app-tab';
import { DriveTestService } from '../../core/services/drive-test.service';

@Component({
    selector: 'app-task-schedule',
    templateUrl: './task-schedule.component.html',
    styleUrls: ['./task-schedule.component.scss']
})
export class TaskScheduleComponent extends FesBaseComponent implements OnInit, OnDestroy {

    @Input() set task(task: any) {
        this._task = task
        this.tmpTask = { ...task.toJSON() }
    }

    @Input() set tabConfig(tabConf: AppTab) {
        tabConf.setSelected = this.onTabSelected
        this.initTabRemovalBehavior(tabConf)
    }

    get task() { return this._task }

    _task: any
    tmpTask: any
    isLoading: boolean = false;
    building: Building = new Building();
    testerUsers: UserDoc[] = []
    currentStatus: string = ""
    public errorMsg: string = ''

    @ViewChild('taskScheduleComments') taskScheduleComments : TaskScheduleCommentsComponent

    constructor(
        public appState: AppState,
        private buildingService: BuildingService,
        private pathTestService: PathTestService,
        private driveTestService: DriveTestService,
        private scoutTaskService: ScoutTaskService,
        private userService: UserService
    ) {
        super(appState)
    }

    ngOnInit(): void {
        this.loadTesters()
    }

    initialize() {
        this.isLoading = true
        this.buildingService.doWhenReady(() => {
            this.setStatus()
            const buildingQuery = this.buildingService.rxCollection.findOne(this._task.buildingId)
            this.subscribe(
                buildingQuery.$,
                async building => {
                    try {
                        this.building = building
                    } catch (error) {
                        this.buildingService.publishError(error, this)
                    } finally {
                        this.isLoading = false
                    }
                },
                error => {
                    this.isLoading = false
                    this.buildingService.publishError(error, this)
                })
        })
    }

    onTabSelected = (bSelected: boolean) => {
        console.log('schedule tab selected: ' + bSelected)
        if (bSelected) {
            this.initialize()
        } else {
            this.unsubscribe()
        }
    }

    ngOnDestroy(): void {
        this.destroy()
    }


    hasUnsavedData = () => {
        return false
    }


    initTabRemovalBehavior(tabConfig: AppTab) {
        tabConfig.hasUnsavedData = this.hasUnsavedData
        const defaultRemove = tabConfig.remove
        tabConfig.remove = (te: TabDirective) => {
            if (!this.hasUnsavedData()) {
                defaultRemove(te)
            } else {
                // this.editor.askDiscardEdits( ()=>defaultRemove(te) ) 
            }
        }
    }

    
    async loadTesters() {
        this.isLoading = true;
        try {
            this.testerUsers = await this.userService.rxCollection.find({
                selector: {
                    role: "field"
                },
                sort: [
                    { firstName: 'asc' },
                    { lastName: 'asc' }
                ]                
            }).exec()
        } catch (error) {
            this.userService.publishError(error, this)
            return
        } finally {
            this.isLoading = false
        }
    }

    async onSaveClick(form: NgForm) {
        this.errorMsg = ''
        this.isLoading = true;
        try {
            if (Task.isScoutTask(this.tmpTask)) {
                await this.scoutTaskService.schedule(this.tmpTask)
            } else if (Task.isPathTestTask(this.tmpTask)) {
                await this.pathTestService.schedule(this.tmpTask)
            } else if (Task.isDriveTestTask(this.tmpTask)) {
                await this.driveTestService.schedule(this.tmpTask)
            }
            form.reset({scheduleDate: this.tmpTask.schedule.scheduledDate, tester: this.tmpTask.assignments.testUserId, notes: this.tmpTask.schedule.scheduleNotes})
            this.setStatus()
        } catch (error) {
            this.errorMsg = this.scoutTaskService.extractErrorMsg(error)
            this.scoutTaskService.publishError(error, this)
        } finally {
            this.isLoading = false
        }
    }

    onCancelClick(form: NgForm) {
        form.reset({scheduleDate: this._task.schedule.scheduledDate, tester: this._task.assignments.testUserId, notes: this._task.schedule.scheduleNotes})
    }

    setStatus() {
        if (this.tmpTask.status) {
            let mostRecentStatusId = TaskStatus.getLatestId(this.tmpTask.status)            
            this.currentStatus = TaskStatus.getStatusName(mostRecentStatusId)
        }
    }

}
